import axios from 'axios';

export default {
    search(context, searchTerm, tags) {

        var self = this;
        var options = {
            url: window.apiUrl + '/search?search_term=' + searchTerm  + '&tags=' + tags,
            method: 'GET',            
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;        
        });
    },
    markAsAnswer(context, postId, topicId) {
        var options = {
            url: window.apiUrl + '/answer',
            headers: {'Authorization': 'Bearer ' + localStorage.token},
            data:{ postId: postId, topicId: topicId },
            method: 'PATCH'
        };
        return axios.request(options).then(function(response) {
            return response;        
        });
    },
    unmarkAnswer(context, postId, topicId) {
        var options = {
            url: window.apiUrl + '/answer',
            headers: {'Authorization': 'Bearer ' + localStorage.token},
            data:{ postId: postId, topicId: topicId },
            method: 'DELETE'
        };
        return axios.request(options).then(function(response) {
            return response;        
        });
    },
    createTag(context, tag) {
        var options = {
            url: window.apiUrl + '/tag',
            headers: {'Authorization': 'Bearer ' + localStorage.token},
            data:{ tag: tag },
            method: 'POST'
        };
        return axios.request(options).then(function(response) {
            return response;        
        });
    },
    getTags(context) {

        var self = this;
        var options = {
            url: window.apiUrl + '/tags',
            method: 'GET',            
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;        
        });
    },
    getCategories(context, subforum) {
        let url = window.apiUrl + '/forum-categories';
        if (subforum) url += '?subforum=' + subforum;

        var self = this;
        var options = {
            url: url,
            method: 'GET',            
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;        
        });
    },
    get(context, forumId, page, userId) {     
        var url = window.apiUrl + '/topics?forum=' + forumId + '&page=' + page;   
        if (userId) {
            url += '&user_id=' + userId;
        }
        var options = {
            url: url,
            method: 'GET',
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;        
        });
    },
    getLatest(context) {
        var options = {
             url: window.apiUrl + '/latest-posts',
            method: 'GET',
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;        
        });
    },
    updateTopic(context, data) {
        var options = {
            url: window.apiUrl + '/topic',
            method: 'PATCH',
            headers: {'Authorization': 'Bearer ' + localStorage.token},
            data: data
        };
        return axios.request(options).then(function(response) {
            return response;        
        }); 
    },
    getPosts(context, topicId, page, userId) { 
        var url = window.apiUrl + '/posts?topic_id=' + topicId + '&page=' + page;    
        if (userId) {
            url += '&user_id=' + userId
        }
        var options = {
            url: url,
            method: 'GET',
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;        
        });
    },
    getParent(context, topicId) { 
        var options = {
            url: window.apiUrl + '/thread/creator?topicId=' + topicId,
            method: 'GET',
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;        
        });
    },
    markAsRead(context, postIds) {
       var options = {
            url: window.apiUrl + '/post/read',
            method: 'PATCH',
            data: { postIds: postIds},
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;        
        }); 
    },
    getReplies(context) {
        var options = {
            url: window.apiUrl + '/replies',
            method: 'GET',
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;        
        });
    },
    getSubForums(context, courses) {        
        var url = window.apiUrl + '/subforums';
        if (courses) {
            url += '?courses=' + courses;
        }
        var options = {
            url: url,   
            method: 'GET',
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;        
        });
    },
    post(context, data) {        
        var options = {
            url: window.apiUrl + '/topic',
            headers: {'Authorization': 'Bearer ' + localStorage.token},
            data:data,
            method: 'POST'
        };
        return axios.request(options).then(function(response) {
            return response;        
        });
    },
    reply(context, data) {        

        var options = {
            url: window.apiUrl + '/reply',
            headers: {'Authorization': 'Bearer ' + localStorage.token},
            data:data,
            method: 'POST'
        };
        return axios.request(options).then(function(response) {
            return response;        
        });
    },
    update(context, data) {        

        var options = {
            url: window.apiUrl + '/post',
            headers: {'Authorization': 'Bearer ' + localStorage.token},
            data:data,
            method: 'PATCH'
        };
        return axios.request(options).then(function(response) {
            return response;        
        });
    },
    delete(context, postId) {        
        
        var options = {
            url: window.apiUrl + '/post/' + postId,
            headers: {'Authorization': 'Bearer ' + localStorage.token},
            method: 'DELETE'
        };
        return axios.request(options).then(function(response) {
            return response;        
        });
    }
};



// WEBPACK FOOTER //
// ./src/services/discussions/index.js